import React, { useEffect, useMemo, useState } from 'react'

const DANGEROUS_SCHEMES = ['javascript:', 'data:', 'vbscript:', 'file:']
const FALLBACK_DELAY_MS = 10000

const sanitizeRedirectUri = (uri: string): string => {
  try {
    const url = new URL(uri)
    if (DANGEROUS_SCHEMES.includes(url.protocol)) {
      return '/'
    }
    return uri
  } catch {
    return '/'
  }
}

interface OAuthSuccessViewProps {
  appName: string
  redirectUri: string
}

export const OAuthSuccessView: React.FC<OAuthSuccessViewProps> = ({ appName, redirectUri }) => {
  const [showFallback, setShowFallback] = useState(false)
  const safeRedirectUri = useMemo(() => sanitizeRedirectUri(redirectUri), [redirectUri])

  useEffect(() => {
    const timer = setTimeout(() => setShowFallback(true), FALLBACK_DELAY_MS)
    return () => clearTimeout(timer)
  }, [])

  return (
    <div className='text-center'>
      <div className='oauth-icon-circle oauth-icon-success mx-auto oauth-mb-40'>
        <i className='bi bi-check-lg fs-2 text-success' />
      </div>

      <h3 className='fw-bold oauth-mb-40'>Connected to Zocks</h3>

      <div className='oauth-user-bar oauth-mb-40'>
        <span className='text-body'>Taking you back to {appName}.</span>
      </div>

      <div role='status' aria-live='polite'>
        {showFallback && (
          <div className='pt-3'>
            <span className='text-muted'>Not redirecting?&nbsp;</span>
            <a href={safeRedirectUri} className='fw-bold text-decoration-underline oauth-link-purple'>
              Click here to continue
            </a>
          </div>
        )}
      </div>
    </div>
  )
}
